import getBoundsOfDistance from 'geolib/es/getBoundsOfDistance';

const ONE_MILE_MEASURED_IN_METERS = 1609.34;
export const getBoundedDistance = (
  latitude: number | undefined,
  longitude: number | undefined,
  distanceInMiles: number,
) =>
  latitude && longitude
    ? // returns [Southwest, Northeast]
      getBoundsOfDistance(
        {
          latitude,
          longitude,
        },
        ONE_MILE_MEASURED_IN_METERS * distanceInMiles,
      )
    : undefined;
